import React, { useContext, useState, useMemo } from "react";
import { formatNumber, makeLink, remap } from "simple-utils";
import { Modal } from "../../components/Modal";
import { AuthContext } from "../../login/AuthContext";
import { FullReportEntry } from "../../models/FullReportEntry";
import { bigNumber, formatMoney } from "../../utils/money-utils";
import { getRegion, stateName } from "../../utils/state-utils";
import { useShortcut } from "../../utils/utils";
import { AccountContext } from "../AccountContext";
import { groupByRegion, groupByState, MiniReport, miniReport } from "./region-report-transformer";

function NumberCard({title, value, formatter = formatMoney}:{title:string, value:number, formatter?:(a:number)=>string}){
    return <div className="mb-2 me-4">
        <div className="opacity-50"><small>{title}</small></div>
        <div>
            {formatter(value)}
        </div>
    </div>
}


function ReportEntry({title, report, className, onClick}:{title: string, report: MiniReport, className:string, onClick?:(e:string)=>void}){
    const user = useContext(AuthContext).user;
    return <div className="mb-4">
        <div className="region-title" style={{margin: "0 0 10px 0"}}><span 
            onClick={onClick ? () => onClick(title) : null}
            style={{borderRadius: "1rem 0"}} className={`bg-${className}`}>{title} <small className={`color-${className}`}>{report.numAccounts}</small></span></div>
        <div className="d-flex flex-wrap">
            <NumberCard title="Leads" value={report.totalLeads} formatter={bigNumber} />
            {user.id == 1 && <NumberCard title="Lead Médio" value={report.avgLeads} formatter={formatNumber} />}
            <NumberCard title="CPL médio" value={report.avgCPL} />
            <NumberCard title="CPM médio" value={report.avgCPM} />
            <NumberCard title="Investimento Total" value={report.totalCost} />
        </div>
    </div>
}

function StateReport({region, accounts, onBack}:{region:string, accounts:FullReportEntry[], onBack:()=>void}){
    const byStateReport = useMemo(()=>{
        var byRegion = groupByState(accounts.filter(a => getRegion(a.state) == region));
        return remap(byRegion, r => miniReport(r)) as Record<string, MiniReport>;
    }, [accounts])

    return  <>     
        <a className="btn btn-secondary btn-sm me-2 mb-4" onClick={onBack}><i className="fa fa-chevron-left"></i> Voltar</a> 
        <h4 className="mb-3">{region}</h4>   
        {Object.entries(byStateReport).map(([k, v]) => <ReportEntry key={k} title={stateName(k)} report={v} className={makeLink(region)} />)}
    </>
}


function RegionReportModal(){
    const {filtered} = useContext(AccountContext);
    const [region, setRegion] = useState<string>(null)

    if(!filtered || !filtered.length) return <p>A lista de contas deve conter ao menos uma conta</p>
    
    const byRegionReport = useMemo(()=>{
        var byRegion = groupByRegion(filtered);
        return remap(byRegion, r => miniReport(r)) as Record<string, MiniReport>;
    }, [filtered])

    if(region)
        return <StateReport onBack={()=>setRegion(null)} region={region} accounts={filtered} />

    return <>  
        <p>Clique na região para ver os detalhes por estado.</p>      
        {Object.entries(byRegionReport).map(([k, v]) => <ReportEntry key={k} title={k} report={v} className={makeLink(k)} onClick={setRegion} />)}
    </>
}

export function RegionReportButton(){
    const [show, setShow] = useState(false);

    useShortcut("KeyR", () => {if(!show) setShow(true)});
    
    return <>
        <button className="btn btn-primary me-2 mb-2" onClick={() => setShow(true)}><i className="fa fa-map"></i> Regiões</button>
        {show && <Modal className="modal-primary modal-lg" onHide={() => setShow(false)} title="Relatório de Regiões"><RegionReportModal /></Modal>}
    </>
}